import * as React from 'react';
import * as styles from './styles.css';
import { Header1 } from '@cian/ui-kit';

export const FileDropZone: React.FC = () => {
  return (
    <div className={styles['container']} data-testid="file-drop-zone">
      <div className={styles['image']}></div>
      <Header1>Вижу файл!</Header1>
      <Header1>Чтобы приложить, просто отпустите его</Header1>
    </div>
  );
};
